// Cloudflare Stream embed origin — single source of truth.
//
// The customer subdomain (`customer-<id>.cloudflarestream.com`) only resolves
// videos owned by that Stream account. As of round-5 D8 every seeded sample
// is uploaded to OUR account, so the customer subdomain is the canonical
// host. The legacy `iframe.videodelivery.net` host stays as a fallback for
// dev environments that don't have the env wired.
//
// Configure via `VITE_CLOUDFLARE_STREAM_CUSTOMER_SUBDOMAIN` at build time
// (set in `.env.local` for dev and in Cloudflare Pages env for prod). Falls
// back to the account-agnostic embed host when the env is empty.
const customer =
  (import.meta.env.VITE_CLOUDFLARE_STREAM_CUSTOMER_SUBDOMAIN as string | undefined) ?? "";

export const STREAM_EMBED_ORIGIN = customer
  ? `https://${customer}`
  : "https://iframe.videodelivery.net";

// Build a player iframe URL with the canonical query params.
export function streamEmbedUrl(
  uid: string,
  opts?: {
    posterUrl?: string;
    autoplay?: boolean;
    muted?: boolean;
    preload?: "auto" | "metadata" | "none";
  },
): string {
  const params = new URLSearchParams();
  params.set("preload", opts?.preload ?? "auto");
  if (opts?.autoplay) params.set("autoplay", "true");
  if (opts?.muted) params.set("muted", "true");
  if (opts?.posterUrl) params.set("poster", opts.posterUrl);
  return `${STREAM_EMBED_ORIGIN}/${uid}?${params.toString()}`;
}
